import React from "react";
import "./GradientText.css";

export default function GradientText({
  children,
  className = "",
  colors = ["#ff5e62", "#ff9966"],
  animationSpeed = 8,
}) {
  const gradient = colors.join(", ");
  return (
    <span
      className={`animated-gradient-text ${className}`}
      style={{
        backgroundImage: `linear-gradient(to right, ${gradient})`,
        animationDuration: `${animationSpeed}s`,
      }}
    >
      {children}
    </span>
  );
}
